import './PublicPageWidgets.css';
import React,{useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import HelpHub from './HelpHub';
import LowCreditsAlert from './LowCreditsAlert';
import CountryBackfillModal from './CountryBackfillModal';

export default function PublicPageWidgets(){
 const {pathname}=useLocation();
 const internal=pathname==='/admin'||pathname.startsWith('/admin/')||pathname==='/os-access';
 const embedded=pathname==='/trust/embed'||pathname.startsWith('/trust/embed/');
 useEffect(()=>{
  if(internal||embedded)return;
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/pageview`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({page:pathname,title:document.title,referrer:document.referrer})}).catch(()=>{});
 },[pathname,internal,embedded]);
 if(internal||embedded)return null;
 return <div data-public-widgets><HelpHub/><LowCreditsAlert threshold={5}/><CountryBackfillModal/></div>;
}
